import React from 'react'
import { Box, Button } from '@chakra-ui/react'
import { systemDocumentInterface } from '../../lib/types'
import { fileInterface } from './multiFileUpload.main'
import { CloseIcon } from '@chakra-ui/icons'
import { FileViewTypeEnum } from '../../commons/common'

export interface dragMovementInterface {
  dragged: number | null
  dropped: number | null
}

export const SegmentBox = ({
  closeCallBack,
  children
}: {
  addButtonText?: string
  closeCallBack?: () => void
  children: React.ReactNode
}): JSX.Element => (
  <Box>
    <Box bg="#fafaff" borderWidth={'1px'} borderColor="#f6f2fb" borderRadius="12px" p="4" m="1" mt="0" pb="2" pt={'5'} position={'relative'} mb="2">
      {children}
      {closeCallBack && (
        <Button
          colorScheme={'orange'}
          position={'absolute'}
          bg="gray.300"
          right="6px"
          top="6px"
          p="1"
          minW="5"
          minH="5"
          h="5"
          onClick={closeCallBack}
        >
          <CloseIcon w="2" h="2" />
        </Button>
      )}
    </Box>
  </Box>
)
// formats incoming data from server to that of fileupload
export const formatDocTypeToFileUpload = (inputData: systemDocumentInterface[]): fileInterface[] => {
  if (Array.isArray(inputData) && inputData.length > 0) {
    const reducedArray = inputData?.reduce((reducer: fileInterface[], item: systemDocumentInterface, index: number) => {
      const fileInterfaceObject: fileInterface = {
        product_doc_id: item.id,
        fileType: {
          id: item.document_type.id
        },
        isPrivateFile: item.document_url?.is_private_file,
        is_hero: (item as any).is_hero ?? false,
        cloudLink: item.document_url?.cdn_url,
        file_id: item.document_url?.id,
        order: index,
        fileViewType: item.document_url?.is_private_file ? FileViewTypeEnum.PRIVATE : FileViewTypeEnum.PUBLIC
      }

      return [...reducer, { ...fileInterfaceObject }]
    }, [])
    return reducedArray
  }
  return []
}

export const getColorScheme = (cloudLink: string): 'red' | 'purple' | 'blue' => {
  switch (cloudLink) {
    case 'loading':
      return 'purple'
    case 'Error':
      return 'red'

    default:
      return 'blue'
  }
}
export const swapArrays = (
  array: unknown[],
  movement: {
    dragged: number | null
    dropped: number | null
  }
): unknown[] | null => {
  if (movement.dropped !== null && movement.dragged !== null) {
    const temp = [...array]
    const removed = temp.splice(movement.dragged, 1)
    temp.splice(movement.dropped, 0, removed[0])
    return temp
  }

  return null
}
